import PropTypes from 'prop-types';
import { useContext } from 'react';
import { NEED_HELP } from '../../config/text/text';
import ThemeContext from '../../providers/ThemeProvider';

const VoucherNeedHelpButton = ({ onClick }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <button className="link" onClick={onClick} type="button">
        {NEED_HELP}
      </button>
      <style jsx>{`
        .link {
          color: ${theme.colors.primary};
          background-color: transparent;
          padding: 0;
          border: none;
          margin-left: auto;
        }
      `}</style>
    </>
  );
};

VoucherNeedHelpButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default VoucherNeedHelpButton;
